import Breadcrumb from "components/commons/bread/Breadcrumb";
import { OrderAdActions, OrderAdPages } from "core/orderAd/orderAd.slice";
import React from "react";
import { useAppDispatch, useAppSelector } from "utils/store";
import { strings } from "../../../intl/fa";

const labels: Record<OrderAdPages, string> = {
  [OrderAdPages.SelectAdType]: strings.order_ad.phases.submit_ad_info,
  [OrderAdPages.DialogMainInfo]: strings.order_ad.phases.submit_ad_info,
  [OrderAdPages.DialogMoreInfo]: strings.order_ad.phases.submit_ad_settings,
  [OrderAdPages.DialogMoreSettings]: strings.order_ad.phases.submit_ad_target,
  [OrderAdPages.DialogPreview]: strings.order_ad.phases.submit_ad_preview,
  [OrderAdPages.Invoice]: strings.order_ad.phases.forth_step,
  [OrderAdPages.AdditionalInfo]: strings.order_ad.phases.fifth_step,
  [OrderAdPages.CampaignMainInfo]: strings.order_ad.phases.first_step,
  [OrderAdPages.CampaignMoreInfo]: strings.order_ad.phases.second_step,
  [OrderAdPages.CampaignMoreSettings]: strings.order_ad.phases.third_step,
  [OrderAdPages.CampaignPreview]: strings.order_ad.phases.forth_step,
  [OrderAdPages.SubmitMyBankAd]: "",
  [OrderAdPages.SubmitOnboardingAd]: "",
  // [OrderAdPages.SponsoredMessageMainInfo]: strings.order_ad.phases.first_step,
  [OrderAdPages.SponsoredMessageViewOptions]:
    strings.order_ad.phases.second_step,
  // [OrderAdPages.SponsoredMessageMoreinfo]: "",
  [OrderAdPages.SponsoredMessagePreview]: strings.order_ad.phases.third_step,

  [OrderAdPages.CampaignSponsoredMessageMainInfo]:
    strings.order_ad.phases.first_step,
  [OrderAdPages.CampaignSponsoredMessageViewOptions]:
    strings.order_ad.phases.second_step,
  [OrderAdPages.CampaignSponsoredMessagePreview]:
    strings.order_ad.phases.third_step,
  [OrderAdPages.CampaignSelectAdType]: strings.order_ad.phases.submit_ad,
  [OrderAdPages.SponsoredMessageMainInfo]:
    strings.order_ad.sponsored_steps.info,
  [OrderAdPages.SponsoredMessageImageStep]:
    strings.order_ad.sponsored_steps.image,
  [OrderAdPages.SponsoredDetails]: strings.order_ad.sponsored_steps.details,
  [OrderAdPages.SponsoredFinalStep]: strings.order_ad.sponsored_steps.final,
};

const AdOrderBreadcrumb: React.FC<React.PropsWithChildren<unknown>> = () => {
  const orderAdPhase = useAppSelector((state) => state.orderAd.page);
  const history = useAppSelector((state) => state.orderAd.history);
  const currentIndex = history.findIndex((page) => page === orderAdPhase);
  const dispatch = useAppDispatch();
  const hide =
    [
      OrderAdPages.SelectAdType,
      OrderAdPages.CampaignSelectAdType,
      OrderAdPages.SubmitOnboardingAd,
      OrderAdPages.SubmitMyBankAd,
      //  OrderAdPages.SponsoredMessageMoreinfo,
    ].includes(orderAdPhase) || currentIndex === 0;

  const onClick = (item: OrderAdPages) => {
    const itemIndex = history.findIndex((page) => page === item);
    const newHistory = history.slice(0, itemIndex + 1);
    dispatch(OrderAdActions.changeBreadcrumb(newHistory));
  };
  if (hide) return null;
  return (
    <Breadcrumb
      data={history.slice(0, currentIndex + 1).map((page, index) => {
        return {
          isActive: orderAdPhase === page,
          label: labels[page],
          onClick: () => {
            if (orderAdPhase !== page) {
              onClick(page);
            }
          },
        };
      })}
    />
  );
};

export default AdOrderBreadcrumb;
